import { unitInstanceFromStep } from '@cards/engine';
import { cardRef, defineGameCard, onResolve, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
export const BattleOrderCard = defineGameCard({
    id: 'battle_order',
    gameplay: {
        type: 'SPELL',
        cost: 2,
        planning: planningTargets([
            targetStep('target', unitTarget({
                side: 'ally', cardTypes: ['UNIT'], cardinality: { min: 1, max: 1 },
            })),
        ]),
    },
    presentation: {
        name: 'Боевой приказ',
        description: 'Выбранный союзный боец получает +2 к атаке.',
        glyph: {
            colors: ['#10213A', '#DC874B', '#FCCB8A', '#EFAD6D', '#B82020'],
            rows: [
                '....111111111111....',
                '...12333333333341...',
                '..1522343333334441..',
                '..1552444444444221..',
                '..122222222222221...',
                '...12222222222241...',
                '...13333555533441...',
                '...14335555553341...',
                '...13355525555341...',
                '...14355522555321...',
                '...14355522555321...',
                '...13455222255321...',
                '...13355522555321...',
                '...13335522553321...',
                '...14333555533321...',
                '...12222222222221...',
                '..1253333333333341..',
                '..1224444434434441..',
                '...15222222222221...',
                '....111111111111....',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('battle_order')],
    abilities: [onResolve((ctx) => {
            const targetId = unitInstanceFromStep(ctx.plan?.selections ?? [], 'target');
            const target = targetId === undefined ? null : ctx.q.instance(targetId);
            if (ctx.self === undefined || target?.zone !== 'board'
                || target.controllerId !== ctx.self.controllerId || ctx.q.cardType(target.id) !== 'UNIT')
                return;
            ctx.ops.addEffect({
                defId: BattleOrderCard.id,
                scope: { kind: 'unit', instanceId: target.id },
                sourceId: ctx.self.id,
                persistent: true,
                statMods: [{ stat: 'attack', op: 'add', value: 2 }],
            });
        })],
    ui: { planning: { steps: { target: { label: 'Выберите союзного бойца' } } } },
});
//# sourceMappingURL=battle_order.js.map